import React, { useState } from 'react';

import Chart from 'chart.js/auto'
import { Bar } from 'react-chartjs-2';
import {
  ResponsiveContainer,
} from 'recharts';

import pageHint from '@images/info.svg';
import Separator from "@components/Separator";
import styles from "./barchart.module.css";

const COLORS = [
  "#00BA88", // Teal
  "#669FF6", // Light Blue
  "#7381EA", // Periwinkle
  "#FF7F50", // Coral
  "#FFD476", // Light Orange
  "#A17FEF", // Purple
  "#FF3407", // Bright Red
  "#4CAF50", // Green
  "#FF9800", // Orange
  "#E91E63", // Pink
  "#2196F3", // Blue
  "#9C27B0", // Deep Purple
  "#FFC107", // Amber
  "#00BCD4", // Cyan
  "#795548", // Brown
  "#607D8B", // Blue Grey
  "#F44336", // Red
  "#3F51B5", // Indigo
  "#8BC34A", // Light Green
  "#009688"  // Teal Green
];


export default function BarChartWidget(props) {
  const labels = props.data.map(item => item.Name);
  const data = props.data.map(item => item.Value);

  const [barData, setBarData] = useState({
    labels: labels,
    datasets: [{
      minBarLength: 3,
      label: props.dataLabel,
      data: data,
      backgroundColor: COLORS,
      borderColor: COLORS,
      borderWidth: 3,
      barThickness: 'flex',
      maxBarThickness: 50,
      borderRadius: 10
    }]
  });

  const [barOptions, setBarOptions] = useState({
    scales: {
      x: {
        ticks: {
          display: false
        },
        grid: {
          display: false
        }
      },
      y: {
        beginAtZero: true
      }
    },
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: true,
        position: (props.legendPosition !== undefined && props.legendPosition !== null) ? props.legendPosition : "bottom",
        align: 'start',
        maxWidth: 300, // Control legend width
        labels: {
          boxWidth: 20,
          padding: 10,
          generateLabels: (chart) => {
            const datasets = chart.data.datasets;
            return chart.data.labels.map((label, i) => {
              const words = label.split(' ');
              let lines = [];
              let currentLine = words[0];
              const maxChars = 15;

              for (let i = 1; i < words.length; i++) {
                if (currentLine.length + words[i].length + 1 <= maxChars) {
                  currentLine += ' ' + words[i];
                } else {
                  lines.push(currentLine);
                  currentLine = words[i];
                }
              }
              lines.push(currentLine);

              return {
                text: lines.join('\n'),
                fillStyle: datasets[0].backgroundColor[i],
                strokeStyle: datasets[0].backgroundColor[i],
                lineWidth: 1,
                hidden: false
              };
            });
          },
          font: {
            size: 12,
            lineHeight: 1.2
          },
          textAlign: 'left',
          color: '#666',
          boxHeight: 8,
          padding: 5
        }
      }
    },
    layout: {
      padding: {
        right: 30, // Add padding for legend
      }
    }
  });



  return (
    <React.Fragment>
      <div className={styles.featuredItem}>
        <span className={styles.featuredTitleHeader}>
          {props.headerTitle}
          <span className="pageHint">
            <img src={pageHint} alt="" />
            <span className="tooltiptext">{props.toolTip}</span>
          </span>
        </span>
        <Separator />
        <span className={styles.featuredTitle}>{props.title}</span>
        <br />
        <span className={styles.featuredSub}>{props.subTitle}</span>

        <div className={styles.featuredTextContainer}>
          <ResponsiveContainer width="99%" aspect={2}> {/* Using aspect ratio instead of fixed height */}
            <Bar
              data={barData}
              options={barOptions}
            />
          </ResponsiveContainer>
        </div>
      </div>


    </React.Fragment>
  );

}
